module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"addPotentialCategories":"Add potential options for this KPI","pressEnterToCreate":"Press <kbd>enter</kbd> to create the category."},"de":{"addPotentialCategories":"Mögliche Optionen für diese KPI hinzufügen","pressEnterToCreate":"Drücken Sie <kbd>Enter</kbd>, um die Kategorie zu erstellen."}}')
  delete Component.options._Ctor
}
